var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-aos":"fade-right"}},[(_vm.templateNumber === 1)?_c('Jobs1',{attrs:{"jobs":_vm.jobs}}):(_vm.templateNumber === 2)?_c('Jobs2',{attrs:{"jobs":_vm.jobs}}):(_vm.templateNumber === 3)?_c('Jobs4',{attrs:{"jobs":_vm.jobs}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }